module.exports = __webpack_public_path__ + "static/media/11.da05bf1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/11.png
// module id = 1252
// module chunks = 0